// src/components/Sections/SeasonExperienceSection/SeasonExperienceSection.jsx

import React from 'react';
import './SeasonExperienceSection.scss';
import seasonScreenshot from '../../../assets/images/marketing/ttg-season-review-phone.png';
import homeScreenshot from '../../../assets/images/marketing/ttg-home-dashboard-phone.png';
import clubScreenshot from '../../../assets/images/marketing/ttg-around-club-phone.png';
import useInView from '../../../hooks/useInView';

// Illustrative member season, not live platform-wide statistics.
const seasonStats = [
  { value: '17', label: 'Rounds' },
  { value: '11', label: 'Courses' },
  { value: '306', label: 'Holes' },
  { value: '84', label: 'Best score' }
];

export default function SeasonExperienceSection() {
  const { ref, isVisible } = useInView({ threshold: 0.18 });

  return (
    <section
      id="season"
      ref={ref}
      className={`season-v4 section-v2 section-v2--soft motion-section ${isVisible ? 'is-visible' : ''}`}
    >
      <div className="container">
        <div className="season-v4__heading motion-copy">
          <div>
            <p className="eyebrow">04 · Your season</p>
            <h2>A golf season worth remembering.</h2>
          </div>
          <p>
            A scorecard is one day. Your season is every round, every course,
            and every little improvement along the way. Keep that history
            together and carry it into the next round.
          </p>
        </div>

        <div className="season-v4__stats" aria-label="Illustrative member season statistics">
          {seasonStats.map((stat) => (
            <div key={stat.label}>
              <strong>{stat.value}</strong>
              <span>{stat.label}</span>
            </div>
          ))}
        </div>
        <p className="season-v4__sample-note">Illustrative member season — example figures</p>

        <div className="season-v4__stage">
          <span className="season-v4__ghost" aria-hidden="true">SEASON</span>

          <figure className="season-v4__phone season-v4__phone--home">
            <img src={homeScreenshot} alt="The Tour Golfers member dashboard" loading="lazy" />
          </figure>

          <figure className="season-v4__phone season-v4__phone--main">
            <img src={seasonScreenshot} alt="The Tour Golfers season review screen" loading="lazy" />
          </figure>

          <figure className="season-v4__phone season-v4__phone--club">
            <img src={clubScreenshot} alt="The Tour Golfers Around the Club recognition feed" loading="lazy" />
          </figure>
        </div>
      </div>
    </section>
  );
}
